export const FETCH_REQUEST = '@review/fetch-request';
export const FETCH_SUCCESS = '@review/fetch-success';
export const FETCH_FAILURE = '@review/fetch-failure';
